export default "__VITE_ASSET__BKeZK34H__"